import React from 'react';
import { User } from '../../types';

interface MobileHeaderProps {
  user: User;
  isMobileMenuOpen: boolean;
  onToggleMenu: () => void;
}

export function MobileHeader({ user, isMobileMenuOpen, onToggleMenu }: MobileHeaderProps) {
  return (
    <div className="mobile-header">
      <div className="mobile-header-content">
        <button 
          className="burger-menu-btn"
          onClick={onToggleMenu}
          aria-label="Toggle menu"
        >
          <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
        <h1 className="mobile-title">SocioSync</h1>
        {user && (
          <div className="mobile-user-info">
            {user.picture && !user.picture.includes('placeholder') && user.picture.startsWith('http') ? (
              <img 
                src={user.picture} 
                alt={user.name} 
                className="mobile-user-avatar"
              />
            ) : (
              <div className="mobile-user-avatar-icon">
                <span className="person-icon">👤</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}


